// Phase 6 — Angular component replacing the AngularJS `GradeTemplatesIndexController`
// (sudo/grade-templates/GradeTemplatesIndexController.js + grade-templates-index.html, both DELETED).
//
// A NATIVE Angular component state (like RoleListComponent): the `sudo.grade-templates` /
// `admin.grade-templates` states in ng/app.routes.ts route directly here, and the angular-hybrid
// `UIViewNgUpgrade` bridge renders it into the ng1 parent's `<ui-view>`.
//
// Full-Material screen: data via the downgraded Angular GradeTemplateService, add/edit-details via
// a MatDialog modal (AddGradeTemplateComponent), delete-confirm via the native ConfirmDialogComponent,
// and success feedback via MatSnackBar (replacing the ng1 toastr). The edit action still navigates to
// the STILL-AngularJS edit page (`*.grade-template-edit`); `^` is resolved relative to the current
// state so it works under both the `sudo` and `admin` parents.
import { Component, inject } from '@angular/core';
import type { OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StateService, UIRouterGlobals } from '@uirouter/angular';
import { AddGradeTemplateComponent } from './add-grade-template.component';
import { GradeTemplateService } from './grade-template.service';
import { ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import { PageHeaderComponent } from '../../components/page-header/page-header.component';

@Component({
    selector: 'grade-templates-list',
    standalone: true,
    imports: [PageHeaderComponent, MatButtonModule, MatIconModule, MatListModule, MatTooltipModule],
    templateUrl: './grade-templates-list.component.html',
    styleUrl: './grade-templates-list.component.css',
})
export class GradeTemplatesListComponent implements OnInit {
    private service = inject(GradeTemplateService);
    private dialog = inject(MatDialog);
    private snackBar = inject(MatSnackBar);
    private stateService = inject(StateService);
    private globals = inject(UIRouterGlobals);

    templates: any[] = [];

    ngOnInit(): void {
        this.load();
    }

    private load(): void {
        this.service.list().then((data) => {
            this.templates = data;
        });
    }

    private notify(message: string): void {
        this.snackBar.open(message, '', { duration: 3000 });
    }

    add(): void {
        this.dialog
            .open(AddGradeTemplateComponent, {
                width: '480px',
                disableClose: true,
                data: { editing: false },
            })
            .afterClosed()
            .subscribe((saved) => {
                if (saved) {
                    this.load();
                    this.notify('შეფასების შაბლონი წარმატებით დაემატა');
                }
            });
    }

    changeDetails(template: any): void {
        this.dialog
            .open(AddGradeTemplateComponent, {
                width: '480px',
                disableClose: true,
                data: { editing: true, gradeTemplate: template },
            })
            .afterClosed()
            .subscribe((saved) => {
                if (saved) {
                    this.load();
                    this.notify('შეფასების შაბლონი წარმატებით დარედაქტირდა');
                }
            });
    }

    edit(template: any): void {
        // `^.grade-template-edit` relative to the current state → sudo.* or admin.* edit page.
        this.stateService.go('^.grade-template-edit', { templateId: template._id }, { relative: this.globals.current });
    }

    viewActivations(template: any): void {
        this.stateService.go('admin.selection', { gradeTemplate: template._id });
    }

    remove(template: any): void {
        this.dialog
            .open(ConfirmDialogComponent, {
                width: '400px',
                data: {
                    title: 'შეფასების შაბლონის წაშლა',
                    message: 'გსურთ წაშლოთ ' + template.name + ' ?',
                },
            })
            .afterClosed()
            .subscribe((confirmed) => {
                if (confirmed) {
                    this.service.remove(template._id).then(() => {
                        this.load();
                        this.notify('შეფასების შაბლონი წარმატებით წაიშალა');
                    });
                }
            });
    }
}
